import _extends from "@babel/runtime/helpers/extends";
import { useHover, usePress } from "@react-aria/interactions";
import { useRadio } from "@react-aria/radio";
import { mergeProps } from "@react-aria/utils";
import { VisuallyHidden } from "@react-aria/visually-hidden";
import React, { forwardRef, useContext, useRef } from "react";
import { ItemContainer } from "./Elements/ItemContainer";
import { ActiveItemContentPlaceholder, ItemContent } from "./Elements/ItemContent";
import { ToggleGroupContext } from "./ToggleGroupContext";
export const ToggleGroupItem = /*#__PURE__*/forwardRef(renderToggleGroupItem);
function renderToggleGroupItem(_ref, ref) {
  let {
    as,
    children,
    contentAs,
    contentProps,
    inputRef: inputRefProp,
    value,
    ...containerProps
  } = _ref;
  const contextState = useContext(ToggleGroupContext);
  if (!contextState) throw new Error("ToggleGroup.Item must be a child of ToggleGroup.Root");
  const {
    state,
    size
  } = contextState;
  const inputRef = useRef(null);
  const handleInputRef = ref => {
    inputRef.current = ref;
    if (!inputRefProp) return;
    if (inputRefProp instanceof Function) inputRefProp(ref);else inputRefProp.current = ref;
  };
  const {
    hoverProps,
    isHovered
  } = useHover({});
  const {
    isPressed: isLabelPressed,
    pressProps
  } = usePress({});
  const {
    inputProps,
    ...radioState
  } = useRadio({
    children,
    value
  }, state, inputRef);
  return /*#__PURE__*/React.createElement(ItemContainer, _extends({
    size: size,
    as: as
  }, containerProps, {
    ref: ref
  }), /*#__PURE__*/React.createElement(VisuallyHidden, null, /*#__PURE__*/React.createElement("input", _extends({}, inputProps, {
    ref: handleInputRef
  }))), " ", /*#__PURE__*/React.createElement(ItemContent, _extends({
    as: contentAs
  }, mergeProps(hoverProps, pressProps), radioState, contentProps, {
    isHovered: isHovered,
    isInvalid: state.isInvalid,
    isPressed: isLabelPressed || radioState.isPressed
  }), children), /*#__PURE__*/React.createElement(ActiveItemContentPlaceholder, _extends({
    "aria-hidden": true,
    as: contentAs
  }, contentProps), children));
}
//# sourceMappingURL=ToggleGroupItem.js.map